import React from 'react'
import { CompleteIcon, IncompleteIcon } from 'secondstep-components'

import ResumeButton from 'components/ResumeButton'
import ReviewButton from 'components/ReviewButton'
import StartButton from 'components/StartButton'

import ResumeLink from 'components/ResumeLink'
import ReviewLink from 'components/ReviewLink'
import StartLink from 'components/StartLink'

const LABELS = {
  NOTSTARTED: 'Not Started',
  INPROGRESS: 'In Progress',
  COMPLETE: 'Complete',
}

const ICONS = {
  INCOMPLETE: <IncompleteIcon />,
  COMPLETE: <CompleteIcon />,
}

export const buttonMap = {
  'not attempted': {
    Button: StartButton,
    icon: ICONS.INCOMPLETE,
    text: LABELS.NOTSTARTED,
  },
  incomplete: {
    Button: ResumeButton,
    icon: ICONS.INCOMPLETE,
    text: LABELS.INPROGRESS,
  },
  completed: {
    Button: ReviewButton,
    icon: ICONS.COMPLETE,
    text: LABELS.COMPLETE,
  },
}

export const linksMap = {
  'not attempted': {
    Button: StartLink,
    icon: ICONS.INCOMPLETE,
    text: LABELS.NOTSTARTED,
  },
  incomplete: {
    Button: ResumeLink,
    icon: ICONS.INCOMPLETE,
    text: LABELS.INPROGRESS,
  },
  completed: {
    Button: ReviewLink,
    icon: ICONS.COMPLETE,
    text: LABELS.COMPLETE,
  },
}
